import { CompanyAttribute } from '../attribute';
import { Language } from '../language.model';
import { CommunicationAudience, CommunicationTypes, ProductDefinition} from 'app/shared/models';
import { CompanyComment } from './company-comment-model';

export interface Company {
  id: number;
  name: string;
  shortName: string;
  internalName: string;
  accountName: string;
  branch: string;
  detailedBranch: string;
  companyLanguages: Language[];
  companyAttributes: CompanyAttribute[];
  companyComments: CompanyComment[];
  restrictedActivationCommunication: boolean;
  smsEnabled: boolean;
  pinEnabled: boolean;
  mySurveysEnabled: boolean;
  isActive: boolean;
  userExternalIdIsMandatory: boolean;
  orgNumber?: string;
  productDefinition?: ProductDefinition;
  branding: CompanyBranding
  type: CompanyType;
  segmentsHierarchyId?: number;
  hasPurgeSettings: boolean;
  productContext: ProductContext;
  tier: string;
  administeredBy: string;
}
export enum ProductContextType {
  EX = 'EX',
  CX = 'CX',
  Kiwi = 'kiwi',
  Custom = 'custom'
}
export interface ProductContext {
  id: number;
  name: string;
  key: ProductContextType;
  showBlog?: boolean;
  organizationEditorType?: OrganizationEditorType;
  emails?: OrganisationEmailSetting[];
}

/**
 * Configures an email sent by the generic organisation/team view for a given trigger (e.g. a
 * manager or a member being added to a team). Mirrors Insight.Database.DB.Entity.OrganisationEmailSetting.
 */
export interface OrganisationEmailSetting {
  trigger: OrganisationEmailTrigger;
  type: CommunicationTypes;
  audience?: CommunicationAudience;
  /** Optional, matches against the company email's bodyModuleKey — disambiguates when a company has more than one active email of the same type+audience. */
  key?: string;
  /** Undefined/true = enabled. */
  enabled?: boolean;
  /** Undefined/false = send at most once per recipient (default). True = this trigger's email may be sent again to someone who already received it. */
  allowResend?: boolean;
}

export enum OrganisationEmailTrigger {
  ManagerAdded = 'ManagerAdded',
  UserAdded = 'UserAdded'
}

export interface CompanyLogo {
  name: string;
  url: string;
  size: number;
}

export interface CompanyBranding {
  primaryColor: string;
  primaryContrastColor: string;
}

export enum OrganizationEditorType {
  'Default' = 'Default',
  'Kiwi' = 'Kiwi'
}

export enum CompanyType {
  'EX' = 'EX',
  'CX' = 'CX'
}

export type CompanyWithAccount = Pick<Company, 'name' | 'id'> & { accountId?: number };

export interface BaseGroup {
  id: number;
  name: string;
  externalId: string;
}
